/*
Version 0.100

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2018
	17-10-2018
	- [BORN] This class is born. Hooray!

!Usage

	-
	
!Wishlist

	none
	
*/
  
var specific_interactions_init = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	/**
	None yet
	**/
	 
	// PRELOAD & DOCUMENT READY  *****************************************************************
	// PRELOAD & DOCUMENT READY *****************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	// PRELOAD & DOCUMENT READY ******************************************************************
	
	this.onready = function() {
		
		/**
		Unbind: Unnecessary listeners
		**/
		//$(document).off('click.cookieWallSubmit');
		//$(document).off('click.cookieWallTabs');
		//$(document).off('click.cookieBarSubmit');
		
		/*
		Close the mobilemenu always on route
		*/
		specific_mobilemenu.toggle(1);

		/*
		Trigger: Instagram
		*/
		//specific_instagram.onready('thumb',8,true);

		/*
		Trigger: Facebook
		*/
		//specific_facebook.onready(6,true);

		/*
		Catch and active URL
		*/
		//specific_interactions.catchAndActiveURL();

		/*
		Popup: Open on load
		*/
		if(
			url[1] == 'login' ||
			url[1] == 'aanmelden' ||
			url[1] == 'wachtwoord-vergeten'
		) {
			popup.open(1,1,url[1]);
		}

		if(
			url[1] == 'gedragscodes'
		) {
			popup.open(1,1,url[1] + '/' + url[2]);
		}

		/*
		Popup in account: Open on load
		*/
		if(
			url[2] == 'lidmaatschap' &&
			url[3] == 'done'
		) {
			popup.open(1,1,'lidmaatschap-start');
		}

		/*
		Popup in account: Open on load
		*/
		if(
			url[2] == 'lidmaatschap' &&
			url[3] == 'losse-les-done'
		) {
			popup.open(1,1,'losse-les-done');
		}

		if(
			url[2] == 'lidmaatschap' &&
			url[3] == 'done-bankrekening'
		) {
			popup.open(1,1,'bankrekening-veranderen-done');
		}

		/*
		Header
		*/
		specific_header.onready();

	};
	
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	
	// none
	
}).apply(specific_interactions_init); 
